import { useState } from "react";
import "../login/login.scss";
import { useNavigate } from "react-router-dom";
import api from "../../services/api";

import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";

const ROLE_NAME_TO_ID = (rolName = "") => {
  const r = String(rolName).trim().toLowerCase();

  if (r === "admin" || r.includes("admin")) return 1;
  if (r.includes("legal")) return 2;
  if (r.includes("atco")) return 3;
  if (r.includes("contrib")) return 4;

  return 0;
};

const Login = () => {
  const [username, setUsername] = useState(""); // email
  const [password, setPassword] = useState("");
  const [remember, setRemember] = useState(false);

  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setErrorMsg("");

    if (!username.trim() || !password.trim()) {
      setErrorMsg("Completa usuario y contraseña.");
      return;
    }

    try {
      setLoading(true);

      const response = await api.post(
        "/login",
        {
          email: username.trim(),
          password: password,
        },
      );

      const { token_type, token, user } = response.data;

      const rolName = user?.rol || "";
      const rol_id = ROLE_NAME_TO_ID(rolName);

      // ✅ Guardar según remember
      const storage = remember ? localStorage : sessionStorage;
      const other = remember ? sessionStorage : localStorage;

      storage.setItem("token_type", token_type || "Bearer");
      storage.setItem("token", token);
      storage.setItem("user", JSON.stringify(user));
      storage.setItem("rol", String(rolName));
      storage.setItem("rol_id", String(rol_id));

      // ✅ Limpiar el otro storage para evitar confusiones
      other.removeItem("token_type");
      other.removeItem("token");
      other.removeItem("user");
      other.removeItem("rol");
      other.removeItem("rol_id");

      navigate("/warehouses");
    } catch (error) {
      const msg =
        error?.response?.data?.message ||
        error?.response?.data?.messages ||
        "No se pudo iniciar sesión.";

      setErrorMsg(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="Login">
      <div className="container-login">
        <div className="avatar-bubble">
          <AccountCircleIcon className="avatar-icon" />
        </div>

        <form className="login-form" onSubmit={handleLogin}>
          <div className="input-pill">
            <PersonOutlineIcon className="pill-icon" />
            <input
              type="text"
              placeholder="Email"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoComplete="username"
            />
          </div>

          <div className="input-pill">
            <LockOutlinedIcon className="pill-icon" />
            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
            />
          </div>

          <div className="row-options">
            <label className="remember">
              <input
                type="checkbox"
                checked={remember}
                onChange={(e) => setRemember(e.target.checked)}
              />
              <span>Remember me</span>
            </label>

            {/* <button type="button" className="link-btn">
              Forgot password?
            </button> */}
          </div>

          {errorMsg && <p className="error-msg">{errorMsg}</p>}

          <button className="btn-login" type="submit" disabled={loading}>
            {loading ? "CARGANDO..." : "LOGIN"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;